import { useParams } from "react-router-dom";
import pressReleasesData from "../../../Components/PressReleasesData.json";
import EachPressReleaseComponent from "../Components/EachPressReleaseComponent/EachPressReleaseComponent";
import EachPressReleaseComponentOldVersion from "../Components/EachPressReleaseComponent/EachPressReleaseComponentOldVersion";
import { Helmet } from "react-helmet";
import "../Styles/DisruptXPressRelease.css";
import "../Styles/MousSigningCeremony.css";
import "../Styles/PressRelease.css";
import "../Styles/PressReleaseWraper.css";
import PageNotFound from "../../../Components/PageNotFound/PageNotFound";

export default function PressReleasePage() {
  const { id } = useParams();
  const pressData = pressReleasesData.find((item) => item.id === id);

  if (!pressData) return <PageNotFound />;

  return (
    <>
      <Helmet>
        <title>{pressData.title}</title>
      </Helmet>

      {!pressData.oldVersion && (
        <EachPressReleaseComponent
          PressHeading={pressData.title}
          PressDate={pressData.date}
          PressDetails={pressData.details}
          PressImage={pressData.image}
          PressImageCaption={pressData.imageCaption}
          PressDetails2={pressData.details2}
          PressImageWidth={pressData.imageWidth}
          ContactTwo={pressData.contactTwo}
          ContactTwoName={pressData.contactTwoName}
          ContactTwoEmail={pressData.contactTwoEmail}
          ContactTwoEmailLink={pressData.contactTwoEmailLink}
          ContactTwoPhone={pressData.contactTwoPhone}
          ContactUsHeading={pressData.contactUsHeading}
          MuizzContact={pressData.MuizzContact}
          OldContactNameOne={pressData.oldContactOne}
          OldContactOneEmailLink={pressData.oldContactOneEmail}
          OldContactNameTwo={pressData.oldContactTwo}
          OldContactTwoEmailLink={pressData.oldContactTwoEamil}
          ForAnyQuery={pressData.forAnyQuery}
          TopDetails={pressData.topDetails}
          SpecialSectionForDisruptX={pressData.SpecialSectionForDisruptX}
          PressImageSlider1={pressData.image1}
          PressImageSlider2={pressData.image2}
        />
      )}
      {pressData.oldVersion && (
        <EachPressReleaseComponentOldVersion
          PressHeading={pressData.title}
          PressDate={pressData.date}
          PressDetails={pressData.details}
          PressImage={pressData.image}
          PressImageWidth={pressData.imageWidth}
          PressDetails2={pressData.details2}
          TopDetails={pressData.topDetails}
        />
      )}
    </>
  );
}
